import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "This application cannot be removed, because it has active accounts assigned to it. You can unassign the application from the accounts, and try again.")
], -1)
const _hoisted_3 = { class: "text-center mt-4" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "text-capitalize" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "d-flex justify-end" }
const _hoisted_9 = { class: "d-flex align-center" }
const _hoisted_10 = { class: "mr-n2" }
const _hoisted_11 = { class: "link" }
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = { class: "d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_ace_editor = _resolveComponent("v-ace-editor")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_combobox = _resolveComponent("v-combobox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      justify: "space-between",
      align: "center",
      dense: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              align: "center",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      color: "#F4F4F4",
                      class: "pa-2 align-content-center",
                      variant: "flat",
                      height: "48"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { dense: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "4",
                              md: "auto"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_dialog, {
                                  width: "500",
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => {_ctx.app = { name: '', type: '', description: '', details: {}, icon: ''}; _ctx.iconSearch = ''; _ctx.iconLibrary = []; _ctx.tab = 'details'})
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_btn, _mergeProps(props, {
                                      size: "small",
                                      variant: "plain",
                                      color: "primary"
                                    }), {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.mdAndUp ? 'Register application' : 'Register'), 1)
                                      ]),
                                      _: 2
                                    }, 1040)
                                  ]),
                                  default: _withCtx(({ isActive }) => [
                                    _createVNode(_component_v_card, { title: "Register an application" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_tabs, {
                                          modelValue: _ctx.tab,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
                                          disabled: !_ctx.app.type
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_tab, { value: "details" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Details")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_tab, { value: "config" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Configuration")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "disabled"]),
                                        _createVNode(_component_v_card_text, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_window, {
                                              modelValue: _ctx.tab,
                                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tab) = $event))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_window_item, { value: "details" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_form, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, {
                                                              cols: "12",
                                                              md: "6"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_text_field, {
                                                                  "hide-details": "",
                                                                  density: "comfortable",
                                                                  label: "Name",
                                                                  modelValue: _ctx.app.name,
                                                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.app.name) = $event))
                                                                }, null, 8, ["modelValue"])
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_col, {
                                                              cols: "12",
                                                              md: "6"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_select, {
                                                                  "hide-details": "",
                                                                  density: "comfortable",
                                                                  label: "Type of application",
                                                                  modelValue: _ctx.app.type,
                                                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.app.type) = $event)),
                                                                  items: _ctx.appTypes,
                                                                  "item-title": "name",
                                                                  "item-value": "type"
                                                                }, null, 8, ["modelValue", "items"])
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_col, { cols: "12" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_textarea, {
                                                                  "hide-details": "",
                                                                  density: "comfortable",
                                                                  label: "Description",
                                                                  modelValue: _ctx.app.description,
                                                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.app.description) = $event))
                                                                }, null, 8, ["modelValue"])
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_col, { cols: "12" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_autocomplete, {
                                                                  "onUpdate:modelValue": _ctx.clearFocus,
                                                                  "center-affix": "",
                                                                  "no-data-text": "Start typing to search..",
                                                                  loading: _ctx.iconListLoading,
                                                                  "onUpdate:search": _ctx.lazyLoadIcons,
                                                                  search: _ctx.iconSearch,
                                                                  clearable: "",
                                                                  "model-value": _ctx.iconSearch,
                                                                  "hide-details": "",
                                                                  density: "comfortable",
                                                                  label: "Application icon",
                                                                  items: _ctx.iconLibrary,
                                                                  "item-value": "name",
                                                                  "item-title": "name",
                                                                  "item-props": true
                                                                }, {
                                                                  item: _withCtx(({ props, item }) => [
                                                                    _createVNode(_component_v_list_item, _mergeProps(props, {
                                                                      "prepend-icon": `mdi-${item.raw.name}`,
                                                                      title: item.raw.name
                                                                    }), null, 16, ["prepend-icon", "title"])
                                                                  ]),
                                                                  selection: _withCtx(({ item }) => [
                                                                    _createVNode(_component_v_list_item, {
                                                                      "prepend-icon": `mdi-${item.raw.name}`,
                                                                      title: item.raw.name
                                                                    }, null, 8, ["prepend-icon", "title"])
                                                                  ]),
                                                                  _: 1
                                                                }, 8, ["onUpdate:modelValue", "loading", "onUpdate:search", "search", "model-value", "items"])
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_window_item, { value: "config" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_ace_editor, {
                                                      class: "ace_editor",
                                                      value: _ctx.appTypes.find((t) => t.type === _ctx.app.type) ? JSON.stringify(_ctx.appTypes.find((t) => t.type === _ctx.app.type).details, null, 2) : '{}',
                                                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => {_ctx.disabled = ''; _ctx.updateEditor($event);}),
                                                      lang: "json",
                                                      theme: "chrome",
                                                      style: {"height":"210px"}
                                                    }, null, 8, ["value"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_card_actions, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_spacer),
                                            _createVNode(_component_v_tooltip, {
                                              text: _ctx.disabled,
                                              location: "bottom",
                                              "open-delay": "200"
                                            }, {
                                              activator: _withCtx(({ props }) => [
                                                (_ctx.disabled.length)
                                                  ? (_openBlock(), _createElementBlock("div", _normalizeProps(_mergeProps({ key: 0 }, props)), [
                                                      _createVNode(_component_v_btn, {
                                                        loading: _ctx.loading,
                                                        disabled: !_ctx.app.name || !_ctx.app.type || _ctx.loading || !!_ctx.disabled.length,
                                                        color: "primary",
                                                        onClick: ($event: any) => {_ctx.registerApp(); isActive.value = false;}
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" Register application ")
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["loading", "disabled", "onClick"])
                                                    ], 16))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1032, ["text"]),
                                            (!_ctx.disabled.length)
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 0,
                                                  loading: _ctx.loading,
                                                  disabled: !_ctx.app.name || !_ctx.app.type || _ctx.loading,
                                                  color: "primary",
                                                  onClick: ($event: any) => {_ctx.registerApp(); isActive.value = false;}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" Register application ")
                                                  ]),
                                                  _: 2
                                                }, 1032, ["loading", "disabled", "onClick"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "4",
                              md: "auto"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_dialog, {
                                  width: "500",
                                  modelValue: _ctx.removeDialog,
                                  "onUpdate:modelValue": [
                                    _cache[9] || (_cache[9] = ($event: any) => ((_ctx.removeDialog) = $event)),
                                    _cache[10] || (_cache[10] = ($event: any) => (_ctx.disabled = ''))
                                  ]
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_btn, _mergeProps(props, {
                                      size: "small",
                                      variant: "plain",
                                      disabled: !_ctx.selectedApplications.length,
                                      color: "primary"
                                    }), {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.mdAndUp ? 'Remove application' : 'Remove'), 1)
                                      ]),
                                      _: 2
                                    }, 1040, ["disabled"])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                      "max-width": "460",
                                      loading: _ctx.loading
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Remove application")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_card_text, null, {
                                          default: _withCtx(() => [
                                            (!!_ctx.disabled.length)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                                  _hoisted_2,
                                                  _createElementVNode("p", _hoisted_3, [
                                                    _createVNode(_component_v_btn, {
                                                      color: "primary",
                                                      variant: "plain",
                                                      onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.editAccounts(_ctx.selectedApplications[0]); _ctx.removeDialog = false; _ctx.deleting = true})
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Open account assignment")
                                                      ]),
                                                      _: 1
                                                    })
                                                  ])
                                                ]))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_4, " Are you sure you want to remove this application? "))
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_card_actions, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_spacer),
                                            _createVNode(_component_v_btn, {
                                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.removeDialog = false))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Cancel ")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_btn, {
                                              loading: _ctx.loading,
                                              disabled: _ctx.loading || !!_ctx.disabled.length,
                                              color: "error",
                                              onClick: _ctx.removeApplication
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Remove ")
                                              ]),
                                              _: 1
                                            }, 8, ["loading", "disabled", "onClick"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["loading"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                _createVNode(_component_v_dialog, {
                                  width: "500",
                                  modelValue: _ctx.removeAccountDialog,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.removeAccountDialog) = $event))
                                }, {
                                  default: _withCtx(({ isActive }) => [
                                    _createVNode(_component_v_card, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Remove " + _toDisplayString(_ctx.currentTenant.name) + " from " + _toDisplayString(_ctx.currentApplication.name) + "?", 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_card_text, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Are you sure you want to remove this account from this application? The users in this account will no longer have access to the application or its data. ")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_card_actions, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_spacer),
                                            _createVNode(_component_v_btn, {
                                              onClick: ($event: any) => (isActive.value = false)
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Cancel ")
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]),
                                            _createVNode(_component_v_btn, {
                                              loading: _ctx.loading,
                                              disabled: _ctx.loading,
                                              color: "primary",
                                              onClick: ($event: any) => {_ctx.saveApplicationTenants(_ctx.currentTenant); isActive.value = false}
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Remove ")
                                              ]),
                                              _: 2
                                            }, 1032, ["loading", "disabled", "onClick"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table, {
      loading: _ctx.loading,
      color: "primary",
      items: _ctx.applications,
      headers: _ctx.headers,
      "show-select": "",
      modelValue: _ctx.selectedApplications,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedApplications) = $event)),
      "select-strategy": "single",
      "items-per-page": "25",
      "return-object": "",
      height: "calc(100vh - 260px)",
      "fixed-header": ""
    }, {
      [`item.icon`]: _withCtx(({ item }) => [
        _createVNode(_component_v_icon, { color: "grey-darken-1" }, {
          default: _withCtx(() => [
            _createTextVNode("mdi-" + _toDisplayString(item.icon), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      [`item.type`]: _withCtx(({ item }) => [
        _createElementVNode("span", _hoisted_5, _toDisplayString(item.type), 1)
      ]),
      [`item.description`]: _withCtx(({ item }) => [
        (item.description.length > 70)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.truncate(item.description)), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.description), 1))
      ]),
      [`item.actions`]: _withCtx(({ item }) => [
        _createVNode(_component_v_menu, null, {
          activator: _withCtx(({ props }) => [
            _createElementVNode("div", _hoisted_8, [
              (item.state !== 'suspended')
                ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, {
                    size: "32",
                    icon: "",
                    variant: "flat",
                    color: "primary"
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "20" }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-dots-vertical")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1040))
                : _createCommentVNode("", true)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, { density: "compact" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item, {
                  onClick: ($event: any) => (_ctx.editApplicationDetails(item)),
                  "prepend-icon": "mdi-application-edit",
                  title: "Edit application"
                }, null, 8, ["onClick"]),
                _createVNode(_component_v_list_item, {
                  onClick: ($event: any) => (_ctx.editApplicationConfiguration(item)),
                  "prepend-icon": "mdi-application-cog",
                  title: "Configure application"
                }, null, 8, ["onClick"]),
                _createVNode(_component_v_list_item, {
                  onClick: ($event: any) => (_ctx.editAccounts(item)),
                  "prepend-icon": "mdi-account-multiple-plus",
                  title: "Account assignment"
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      [`item.accounts`]: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getApplicationTenantAccess(item), (tenant, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "d-flex",
              key: tenant.id
            }, [
              _createElementVNode("div", _hoisted_10, [
                (index < 5)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      text: tenant.name,
                      location: "bottom",
                      "open-delay": "200"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                          size: "32",
                          style: {"border":"2px solid #ffffff"},
                          icon: "",
                          variant: "flat",
                          color: "primary",
                          onClick: ($event: any) => {_ctx.currentApplication = {...item}; _ctx.currentTenant = tenant; _ctx.removeAccountDialog = true;}
                        }), {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tenant.name.charAt(0)), 1)
                          ]),
                          _: 2
                        }, 1040, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["text"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          (_ctx.getApplicationTenantAccess(item).length > 5)
            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                key: 0,
                location: "bottom",
                "open-delay": "200"
              }, {
                activator: _withCtx(({ props }) => [
                  _createElementVNode("div", _mergeProps(props, { class: "ml-4" }), [
                    _createElementVNode("a", _hoisted_11, "+ " + _toDisplayString(_ctx.getApplicationTenantAccess(item).length - 5) + " more", 1)
                  ], 16)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.remainingTenantNames(item), (tenant) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tenant.id
                    }, _toDisplayString(tenant.name), 1))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, 1032, ["loading", "items", "headers", "modelValue"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.editAccountsDialog,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editAccountsDialog) = $event)),
      onAfterLeave: _cache[17] || (_cache[17] = ($event: any) => {_ctx.tenantsToAdd = []; _ctx.tenantsToRemove = [];})
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(" Add or remove accounts from " + _toDisplayString(_ctx.currentApplication.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "pb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              block: "",
                              rounded: "pill",
                              color: "primary",
                              variant: "flat",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addTenantRow(_ctx.currentApplication))),
                              disabled: !_ctx.filteredTenantsList.length
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Add account ")
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "pb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              block: "",
                              rounded: "pill",
                              color: "primary",
                              variant: "flat",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addAllTenants(_ctx.currentApplication))),
                              disabled: !_ctx.filteredTenantsList.length
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Add all accounts")
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "pb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              block: "",
                              rounded: "pill",
                              color: "primary",
                              variant: "flat",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.removeAllTenants(_ctx.currentApplication)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Remove all accounts")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "pt-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationTenants, (tenant) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: tenant.name,
                                    style: {"background-color":"rgba(0,0,0,0.05)"},
                                    rounded: "",
                                    class: "my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        class: "flex-nowrap",
                                        justify: "space-between",
                                        align: "center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "11" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(tenant.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, { cols: "1" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_action, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_dialog, { attach: true }, {
                                                    activator: _withCtx(({ props }) => [
                                                      _createVNode(_component_v_btn, _mergeProps(props, {
                                                        icon: "",
                                                        variant: "flat",
                                                        color: "transparent",
                                                        size: "32"
                                                      }), {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_icon, {
                                                            icon: "mdi-delete",
                                                            color: "primary",
                                                            size: "24"
                                                          })
                                                        ]),
                                                        _: 2
                                                      }, 1040)
                                                    ]),
                                                    default: _withCtx(({ isActive }) => [
                                                      _createVNode(_component_v_card, {
                                                        "max-width": "460",
                                                        "min-height": "200"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_card_title, null, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode("Remove account from application")
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_v_card_text, null, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(" Are you sure you want to remove this account from this application? Users in this account will no longer have access to the application or its data. ")
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_v_card_actions, null, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_spacer),
                                                              _createVNode(_component_v_btn, {
                                                                onClick: ($event: any) => (isActive.value = false)
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(" Cancel ")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onClick"]),
                                                              _createVNode(_component_v_btn, {
                                                                loading: _ctx.loading,
                                                                disabled: _ctx.loading,
                                                                color: "primary",
                                                                onClick: ($event: any) => {_ctx.removeTenantFromApplication(tenant); isActive.value = false}
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(" Remove ")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["loading", "disabled", "onClick"])
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tenantsToAdd, (tenant) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: tenant.name,
                                    style: {"background-color":"rgba(0,0,0,0.05)"},
                                    rounded: "",
                                    class: "my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        justify: "space-between",
                                        align: "center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "11" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(tenant.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, { cols: "1" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_action, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_btn, {
                                                    icon: "",
                                                    variant: "flat",
                                                    color: "transparent",
                                                    size: "32",
                                                    onClick: ($event: any) => (_ctx.removeNewTenant(tenant))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_icon, {
                                                        icon: "mdi-delete",
                                                        color: "primary",
                                                        size: "24"
                                                      })
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newTenants, (tenant) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    class: "mb-1 px-0 pt-0",
                                    key: tenant.name
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_combobox, {
                                        class: "app-combobox",
                                        clearable: "",
                                        items: _ctx.filteredTenantsList,
                                        "item-title": "name",
                                        "hide-details": "",
                                        density: "comfortable",
                                        placeholder: "Search accounts",
                                        "return-object": "",
                                        "menu-props": { maxWidth: 452 }
                                      }, {
                                        selection: _withCtx(({ item }) => [
                                          _createElementVNode("div", _hoisted_12, [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.raw.name), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ])
                                        ]),
                                        item: _withCtx(({ item }) => [
                                          _createElementVNode("div", _hoisted_13, [
                                            _createVNode(_component_v_list_item, {
                                              onClick: ($event: any) => {_ctx.newTenant = item.raw; _ctx.addTenantAccess()}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.raw.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["items"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _ctx.saveApplicationTenants,
                  loading: _ctx.loading,
                  disabled: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Save application ")
                  ]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.editApplicationDetailsDialog,
      "onUpdate:modelValue": [
        _cache[21] || (_cache[21] = ($event: any) => ((_ctx.editApplicationDetailsDialog) = $event)),
        _cache[22] || (_cache[22] = ($event: any) => (_ctx.iconSearch = ''))
      ]
    }, {
      default: _withCtx(({ isActive }) => [
        _createVNode(_component_v_card, { title: "Edit application" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              "hide-details": "",
                              density: "comfortable",
                              label: "Name",
                              modelValue: _ctx.currentApplication.name,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.currentApplication.name) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              class: "text-capitalize",
                              disabled: "",
                              "hide-details": "",
                              density: "comfortable",
                              label: "Type of application",
                              modelValue: _ctx.currentApplication.type,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.currentApplication.type) = $event)),
                              "item-title": "name",
                              "item-value": "type"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_textarea, {
                              "hide-details": "",
                              density: "comfortable",
                              label: "Description",
                              modelValue: _ctx.currentApplication.description,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.currentApplication.description) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_autocomplete, {
                              "onUpdate:modelValue": _ctx.clearFocus,
                              "center-affix": "",
                              "no-data-text": "Start typing to search..",
                              loading: _ctx.iconListLoading,
                              "onUpdate:search": _ctx.lazyLoadIcons,
                              search: _ctx.iconSearch,
                              clearable: "",
                              "model-value": _ctx.iconSearch,
                              "hide-details": "",
                              density: "comfortable",
                              label: "Application icon",
                              items: _ctx.iconLibrary,
                              "item-value": "name",
                              "item-title": "name",
                              "item-props": true
                            }, {
                              item: _withCtx(({ props, item }) => [
                                _createVNode(_component_v_list_item, _mergeProps(props, {
                                  "prepend-icon": `mdi-${item.raw.name}`,
                                  title: item.raw.name
                                }), null, 16, ["prepend-icon", "title"])
                              ]),
                              selection: _withCtx(({ item }) => [
                                _createVNode(_component_v_list_item, {
                                  "prepend-icon": `mdi-${item.raw.name}`,
                                  title: item.raw.name
                                }, null, 8, ["prepend-icon", "title"])
                              ]),
                              _: 1
                            }, 8, ["onUpdate:modelValue", "loading", "onUpdate:search", "search", "model-value", "items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_tooltip, {
                  text: _ctx.disabled,
                  location: "bottom",
                  "open-delay": "200"
                }, {
                  activator: _withCtx(({ props }) => [
                    (_ctx.disabled.length)
                      ? (_openBlock(), _createElementBlock("div", _normalizeProps(_mergeProps({ key: 0 }, props)), [
                          _createVNode(_component_v_btn, {
                            loading: _ctx.loading,
                            disabled: !_ctx.currentApplication.name || !!_ctx.disabled.length,
                            color: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Save application ")
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled"])
                        ], 16))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["text"]),
                (!_ctx.disabled.length)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      loading: _ctx.loading,
                      disabled: !_ctx.currentApplication.name || _ctx.loading,
                      color: "primary",
                      onClick: ($event: any) => {_ctx.saveApplication(); isActive.value = false;}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Save application ")
                      ]),
                      _: 2
                    }, 1032, ["loading", "disabled", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.editApplicationConfigurationDialog,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.editApplicationConfigurationDialog) = $event))
    }, {
      default: _withCtx(({ isActive }) => [
        _createVNode(_component_v_card, {
          title: `Edit configuration for ${_ctx.currentApplication.name}`,
          height: "350"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_ace_editor, {
                  class: "ace_editor",
                  value: JSON.stringify(_ctx.currentApplication.details, null, 2) || '{}',
                  "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => {_ctx.disabled = ''; _ctx.updateEditor($event);}),
                  lang: "json",
                  theme: "chrome",
                  style: {"height":"210px"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_tooltip, {
                  text: _ctx.disabled,
                  location: "bottom",
                  "open-delay": "200"
                }, {
                  activator: _withCtx(({ props }) => [
                    (_ctx.disabled.length)
                      ? (_openBlock(), _createElementBlock("div", _normalizeProps(_mergeProps({ key: 0 }, props)), [
                          _createVNode(_component_v_btn, {
                            loading: _ctx.loading,
                            disabled: !!_ctx.disabled.length,
                            color: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Save application ")
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled"])
                        ], 16))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["text"]),
                (!_ctx.disabled.length)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      loading: _ctx.loading,
                      disabled: !_ctx.currentApplication.name || _ctx.loading,
                      color: "primary",
                      onClick: ($event: any) => {_ctx.saveApplication(); isActive.value = false;}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Save application ")
                      ]),
                      _: 2
                    }, 1032, ["loading", "disabled", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["title"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}